import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IActivityLogSplitPanelState } from "./definitions";
import { ActivityItem } from "components/activity-logs/activity-log/definitions";

const initialState: IActivityLogSplitPanelState = {
  selectedActivity: null,
  isOpen: false,
};

export const activityLogSplitPanelSlice = createSlice({
  name: "activityLogSplitPanel",
  initialState,
  reducers: {
    setSelectedActivity: (
      state,
      action: PayloadAction<ActivityItem | null>
    ) => {
      state.selectedActivity = action.payload;
    },
    setSplitPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { setSelectedActivity, setSplitPanelOpen } =
  activityLogSplitPanelSlice.actions;

export default activityLogSplitPanelSlice.reducer;
